var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1217,
    height: 62,
    viewBox: "0 0 1217 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_380_11457)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_380_11457",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.900391 -0.15625H1216.9V61.8438H0.900391V-0.15625Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-142.248 71.5791L386.862 -674.939",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-134.09 77.3618L395.02 -669.156",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125.931 83.144L403.179 -663.374",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117.772 88.9268L411.338 -657.591",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109.614 94.7095L419.496 -651.808",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101.455 100.492L427.655 -646.026",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.2969 106.274L435.813 -640.244",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85.1377 112.057L443.972 -634.461",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.9795 117.839L452.131 -628.679",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.8213 123.622L460.289 -622.896",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-60.6621 129.405L468.448 -617.113",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.5039 135.187L476.606 -611.331",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44.3457 140.97L484.764 -605.548",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36.1865 146.752L492.923 -599.766",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.0283 152.535L501.082 -593.983",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.8691 158.317L509.241 -588.201",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.7109 164.1L517.399 -582.418",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.55273 169.882L525.557 -576.636",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60645 175.665L533.716 -570.853",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7646 181.448L541.875 -565.07",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9229 187.23L550.033 -559.288",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.082 193.013L558.192 -553.505",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2402 198.795L566.35 -547.723",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3984 204.578L574.508 -541.94",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5576 210.36L582.668 -536.158",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7158 216.143L590.826 -530.375",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.875 221.925L598.985 -524.593",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0332 227.708L607.143 -518.81",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1914 233.49L615.301 -513.028",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3506 239.273L623.461 -507.245",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.509 245.056L631.619 -501.462",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.667 250.838L639.777 -495.68",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.826 256.621L647.936 -489.897",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.984 262.403L656.094 -484.115",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.143 268.186L664.253 -478.332",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.302 273.968L672.412 -472.55",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.46 279.751L680.57 -466.767",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.619 285.533L688.729 -460.985",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.777 291.316L696.887 -455.202",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.936 297.099L705.046 -449.419",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.095 302.881L713.205 -443.637",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.253 308.664L721.363 -437.854",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.411 314.446L729.521 -432.072",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.57 320.229L737.68 -426.289",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.729 326.011L745.839 -420.507",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.888 331.794L753.998 -414.724",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.046 337.576L762.156 -408.942",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.204 343.359L770.314 -403.159",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.363 349.142L778.473 -397.376",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.521 354.924L786.631 -391.594",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.68 360.707L794.79 -385.811",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.839 366.489L802.949 -380.029",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.997 372.271L811.107 -374.246",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.155 378.054L819.265 -368.464",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.314 383.837L827.424 -362.681",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.473 389.619L835.583 -356.899",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.632 395.402L843.742 -351.116",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.79 401.185L851.9 -345.333",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.948 406.967L860.058 -339.551",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.107 412.75L868.217 -333.768",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.266 418.532L876.376 -327.986",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.424 424.314L884.534 -322.204",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.583 430.097L892.693 -316.421",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.741 435.88L900.851 -310.638",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.899 441.662L909.009 -304.856",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.059 447.445L917.169 -299.073",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.217 453.228L925.327 -293.29",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.376 459.01L933.486 -287.508",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.534 464.792L941.644 -281.725",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.692 470.575L949.802 -275.943",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.852 476.357L957.962 -270.161",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.01 482.14L966.12 -264.378",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.168 487.923L974.278 -258.595",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.327 493.705L982.437 -252.813",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.485 499.488L990.595 -247.03",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.645 505.27L998.755 -241.248",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.803 511.053L1006.91 -235.465",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.961 516.835L1015.07 -229.683",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.12 522.618L1023.23 -223.9",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.278 528.4L1031.39 -218.118",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.437 534.183L1039.55 -212.335",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.596 539.965L1047.71 -206.553",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.754 545.748L1055.86 -200.77",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.912 551.531L1064.02 -194.987",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.071 557.313L1072.18 -189.205",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.229 563.096L1080.34 -183.422",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.389 568.878L1088.5 -177.64",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.547 574.661L1096.66 -171.857",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.705 580.443L1104.82 -166.075",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.864 586.226L1112.97 -160.292",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.022 592.008L1121.13 -154.51",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.181 597.791L1129.29 -148.727",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.34 603.574L1137.45 -142.944",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.498 609.356L1145.61 -137.162",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.657 615.139L1153.77 -131.379",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.815 620.921L1161.93 -125.597",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.974 626.704L1170.08 -119.814",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.133 632.486L1178.24 -114.032",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.291 638.269L1186.4 -108.249",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.449 644.051L1194.56 -102.467",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.608 649.834L1202.72 -96.684",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.767 655.617L1210.88 -90.9013",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.925 661.399L1219.03 -85.119",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.084 667.182L1227.19 -79.3363",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.242 672.964L1235.35 -73.5536",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.401 678.747L1243.51 -67.7714",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.56 684.529L1251.67 -61.9887",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.718 690.312L1259.83 -56.2059",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.877 696.094L1267.99 -50.4237",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.035 701.877L1276.15 -44.641",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.193 707.66L1284.3 -38.8583",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.353 713.442L1292.46 -33.0761",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.511 719.225L1300.62 -27.2933",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.669 725.007L1308.78 -21.5106",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.828 730.79L1316.94 -15.7284",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.986 736.572L1325.1 -9.94569",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.146 742.355L1333.26 -4.16298",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.304 748.137L1341.41 1.61925",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.462 753.92L1349.57 7.40196",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.621 759.703L1357.73 13.1847",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.779 765.485L1365.89 18.9669",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.938 771.268L1374.05 24.7496",
    stroke: "#E8E2F4",
    strokeOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1216.9 60.8438H0.900391V62.8438H1216.9V60.8438Z",
    fill: "#E8E2F4",
    mask: "url(#path-1-inside-1_380_11457)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_380_11457"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.900391 -0.15625H1216.9V61.8438H0.900391V-0.15625Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.916ec6851433aa81b45987ab3736135d.svg";
export { ForwardRef as ReactComponent };